(function () {
   'use strict';

   module.exports = AssetCoreAudio;
   var AssetCoreMedia = require('./media.js');
   var logger = new (require('../helpers/logger.js'))("ACMediaAudio").setColor("goldenrod").setDebug(true);

  function AssetCoreAudio(detailJson){
    AssetCoreMedia.call(this, detailJson); // call super constructor.
    logger.debug("creating AssetCoreAudio with defaultQuality '"+this.defaultQualityName()+"' from json:", detailJson);
  }

  // subclass extends superclass
  AssetCoreAudio.prototype = Object.create(AssetCoreMedia.prototype);
  AssetCoreAudio.prototype.constructor = AssetCoreMedia;

  AssetCoreAudio.prototype.url = function(){
    return this._defaultQuality().detail.url;
  };

  AssetCoreAudio.prototype.durationMs = function(){
    return this._defaultQuality().detail.durationMs;
  };

}());



//////////////////
// WEBPACK FOOTER
// ./src/AssetCore/mediaAudio.js
// module id = 23
// module chunks = 0